"use client";
import "../chunk-GOCCUU3Z.js";
const getDeviceLogo = (vendor, isMobile) => {
  switch (vendor == null ? void 0 : vendor.toLowerCase()) {
    case "apple": {
      return "apple";
    }
    case "samsung": {
      return "samsung";
    }
    case "lenovo": {
      return "lenovo";
    }
    case "lg": {
      return "lg";
    }
    case "motorola": {
      return "motorola";
    }
    case "dell": {
      return "dell";
    }
    case "hp": {
      return "hp";
    }
    default: {
      if (isMobile) {
        return "phone";
      }
      return "laptop";
    }
  }
};
export {
  getDeviceLogo
};
